import { type ThemeMode } from '@tokenterminal/ui/Theme/ThemeContext'
import { type CustomChartThemeId } from './themes'

/*
 * NOTE: Could be streamlined if makes sense. As such it clearly communicates color scheme and transforms that to chart theme.
 * I assume we could use "light" and "dark" theme in chart, but it's somewhat unclear to me what is the link between these and our "ag-theme-tokenterminal" (CSS), if any.
 *
 */
export const getCurrentTheme = (bodyElement: Element): ThemeMode =>
  bodyElement.classList.contains('light') ? 'light' : 'dark'

export const getChartTheme = (mode: ThemeMode): CustomChartThemeId =>
  mode === 'light' ? 'tokenterminalLight' : 'tokenterminal'

export const getCurrentChartTheme = (): CustomChartThemeId =>
  (typeof document !== 'undefined' &&
    getChartTheme(getCurrentTheme(document.body))) ||
  'tokenterminal'

let bodyObserver: undefined | MutationObserver
export const onColorSchemeUpdate = (
  callback: (mode: 'light' | 'dark') => void,
) => {
  bodyObserver =
    bodyObserver ??
    new MutationObserver(([mutation]) => {
      if (mutation.attributeName === 'class') {
        callback(getCurrentTheme(mutation.target as Element))
      }
    })
  bodyObserver.observe(document.body, {
    attributes: true,
    childList: false,
    subtree: false,
  })
  return () => {
    // Return cleanup
    bodyObserver?.disconnect()
    bodyObserver = undefined
  }
}
